import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import { createMap, locationIcon, defaultMapSettings } from '../../../utils/leafletConfig';
import * as primarycolor from '../../primarycolor';

const PolylineMap_Other = ({ initialCoordinates }) => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markerRef = useRef(null);

  useEffect(() => {
    // Initialize map
    if (mapRef.current && !mapInstanceRef.current) {
      mapInstanceRef.current = createMap(mapRef.current);
    }
    
    return () => {
      // Cleanup on unmount
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (!mapInstanceRef.current) return;

    // Clear existing marker
    if (markerRef.current) {
      mapInstanceRef.current.removeLayer(markerRef.current);
      markerRef.current = null;
    }

    // Add new marker if coordinates are available
    if (initialCoordinates && initialCoordinates.location_lat && initialCoordinates.location_lng) {
      const lat = Number(initialCoordinates.location_lat);
      const lng = Number(initialCoordinates.location_lng);
      
      if (!isNaN(lat) && !isNaN(lng)) {
        markerRef.current = L.marker([lat, lng], { icon: locationIcon })
          .bindPopup(`
            <div>
              <strong>Location</strong><br/>
              Address: ${initialCoordinates.Address || 'N/A'}<br/>
              Coordinates: (${initialCoordinates.location_lat}, ${initialCoordinates.location_lng})
            </div>
          `)
          .addTo(mapInstanceRef.current);

        // Center map on the marker
        mapInstanceRef.current.setView([lat, lng], defaultMapSettings.zoom);
      }
    } else {
      // If no coordinates, center on default location (Kampala)
      mapInstanceRef.current.setView(defaultMapSettings.center, defaultMapSettings.zoom);
    }
  }, [initialCoordinates]);

  return (
    <div 
      ref={mapRef}
      style={{
        width: '100%',
        height: '400px',
        border: '1px solid #ccc',
        borderRadius: '4px'
      }}
    />
  );
};

export default PolylineMap_Other;